import React, { useState } from 'react';
import { ToastContent, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from 'services/coversationService';
import brandLogo from '../../assets/images/logo.svg'
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';
import { useDispatch } from 'react-redux';
import { handleLoader } from 'redux/counterSlice';

const ResetPassword = () => {
    const [formValue, setFormValue] = useState({
        email: localStorage.getItem("email"),
        password: "",
        confirmPassword: "",
    });
    const dispatch = useDispatch();
    const [errors, setErrors] = useState<any>({});
    const [showPassword, setShowPassword] = useState(false);
    const [showCnfPassword, setShowCnfPassword] = useState(false);
    const navigate = useNavigate();
    const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
    };

    const handleValidation = (formValue: { [x: string]: any }) => {
        const errors: { [x: string]: any } = {};
        if (!formValue.password) {
            errors.password = 'Password is required';
        }
        if (formValue.password && !passRegex.test(formValue.password)) {
            errors.password = 'Password must be of minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character';
        }
        if (!formValue.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required';
        }
        if (formValue.confirmPassword !== formValue.password) {
            errors.confirmPassword = 'Confirm Password does not match with the new password';
        }
        return errors;
    }

    const handleReset = async (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        // Perform validation
        const validationErrors = handleValidation(formValue);

        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await forgotPassword(formValue);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                // setTimeout(() => {
                if (localStorage.getItem('clientName') !== 'Amspec_clone') {
                    navigate("/login")
                } else {
                    navigate("/login?env=AmSpec")
                }
                // }, 2500)
            } catch (error) {
                dispatch(handleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }

    const logos = JSON.parse(localStorage.getItem('logos') as any);
    const logo = logos !== null || logos !== "" ? `data:image/png;base64,${logos?.logo_side_img}` : brandLogo;

    return (
        <div className="login-container">
            <div className='login-main'>
                {/* <div className='login-left'>
                    <div className='login-left_top'>
                        <img src={register} className='left-image' alt="signup" />
                    </div>
                    <div className='login-left_bottom'></div>
                </div> */}
                <div className='login-right'>
                    <img src={logo} className='logo' alt="logo" />
                    <h3 className='login-header'>Reset your password</h3>
                    <form className='form'>

                        <div className='form-field2'>
                            <label className='form-label'>Password <span className="text-red-600">*</span></label>
                            <div className='password'>
                                <input
                                    className="form-control"
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Enter your Password"
                                    required
                                    value={formValue.password}
                                    onChange={(e) => {
                                        delete errors.password;
                                        handleChange(e);
                                    }}
                                    autoComplete="new-password"
                                />
                                <span className={`password-toggle `} onClick={() => setShowPassword(!showPassword)}>
                                    {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                        <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                    }
                                </span>
                            </div>
                        </div>
                        {errors.password && <span className="mt-2 text-danger">{errors.password}</span>}
                        <div className='form-field2'>
                            <label className='form-label'>Confirm Password <span className="text-red-600">*</span></label>
                            <div className='password'>
                                <input
                                    className="form-control"
                                    type={showCnfPassword ? "text" : "password"}
                                    placeholder="Confirm your Password"
                                    name='confirmPassword'
                                    required
                                    value={formValue.confirmPassword}
                                    onChange={(e) => {
                                        delete errors.confirmPassword;
                                        handleChange(e);
                                    }}
                                    autoComplete="new-password"
                                />
                                <span className={`password-toggle `} onClick={() => setShowCnfPassword(!showCnfPassword)}>
                                    {!showCnfPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                        <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                    }
                                </span>
                            </div>
                        </div>
                        {errors.confirmPassword && <span className="mt-2 text-danger">{errors.confirmPassword}</span>}
                        <button className='btn btn-primary mt-4 w-100' onClick={handleReset}>Reset</button>
                        <p className='register-text text-center mt-2'>Go Back to <strong onClick={() => navigate("/", { replace: true })} className='str-point'>Sign In</strong></p>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default ResetPassword